import { ApiClientError, ApiClientTransportError } from '@contract-analyzer/api-client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useEffect, useState, type ReactNode } from 'react';

/** Remounted at the authenticated tenant boundary; grid snapshots keep their separate lifetime. */
export function TenantQueryProvider({ children }: { readonly children: ReactNode }): ReactNode {
  const [client] = useState(() => new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: (count, error) => count < 1 && (error instanceof ApiClientTransportError || !(error instanceof ApiClientError) || error.status >= 500),
      },
    },
  }));
  useEffect(() => () => { client.clear(); }, [client]);
  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
